export enum TabID {
	Teacher = 'Teacher',
	Specialists = 'Specialists',
	PreAssess = 'PreAssess',
}
